import {
  ColumnChooser,
  FilterRow,
  HeaderFilter,
  Paging,
  Scrolling,
  SearchPanel,
  StateStoring
} from 'devextreme-react/data-grid';
import { OpsGridStateStoring } from './OpsGridStateStoring';

export interface OpsSiteGridChromeProps {
  stateStorageKey: string;
  schemaVersion?: number;
  /** Stable column identifiers for persisted layout/filter sanitization. */
  stateColumns?: readonly string[];
  searchPlaceholder?: string;
  searchWidth?: number;
  pageSize?: number;
  /**
   * When false, paging is disabled (`<Paging enabled={false} />`).
   * Do not combine with your own `<Paging>` / `<Pager>` — that pair will lose.
   * For a custom remote pager, omit this chrome and wire Paging/Pager yourself
   * (see UserActivityHistoryGrid / CursorUsage events grid).
   */
  showPaging?: boolean;
  showFilterRow?: boolean;
  showHeaderFilter?: boolean;
}

/** Standard DataGrid chrome for full-bleed ops site pages. */
export function OpsSiteGridChrome({
  stateStorageKey,
  schemaVersion = 1,
  stateColumns,
  searchPlaceholder = 'Search…',
  searchWidth = 240,
  pageSize = 50,
  showPaging = true,
  showFilterRow = false,
  showHeaderFilter = true
}: OpsSiteGridChromeProps) {
  return (
    <>
      {stateColumns && stateColumns.length > 0 ? (
        <OpsGridStateStoring
          storageKey={stateStorageKey}
          schemaVersion={schemaVersion}
          columns={stateColumns}
        />
      ) : (
        <StateStoring enabled type="localStorage" storageKey={stateStorageKey} savingTimeout={500} />
      )}
      <SearchPanel visible width={searchWidth} placeholder={searchPlaceholder} />
      {showHeaderFilter ? <HeaderFilter visible /> : null}
      {showFilterRow ? <FilterRow visible /> : null}
      <ColumnChooser enabled mode="select" allowSearch title="Choose columns" height={400} width={280} />
      <Scrolling mode="standard" scrollByThumb showScrollbar="onScroll" useNative />
      {showPaging ? <Paging defaultPageSize={pageSize} /> : <Paging enabled={false} />}
    </>
  );
}
